<template>
    <b-container fulid class="bv-example-row" style="margin-bottom: 17px;">
    <b-row >
      <p class="p1">联系我们</p>
    
    </b-row>
    <!-- <b-row style="margin: 40px auto;">
      <b-col cols="12" sm="12" md="12" lg="4" xl="4">
        <div class="fxe">
        <b-img
        style="margin-right: 25px;"
          class="img"
          :src="img1"
        ></b-img>
        <span class="spans">400-181-9877</span>
      </div>
      </b-col>
      <b-col cols="12" sm="12" md="12" lg="4" xl="4">
        <div class="fxe">
          <b-img
          style="margin-right: 25px;"
            class="img"
            :src="img2"
          ></b-img>
        <span class="spans">13081010175</span>
      </div>
      </b-col>
      <b-col cols="12" sm="12" md="12" lg="4" xl="4">
        <div class="fxe">
          <b-img
            class="img"
            :src="img2"
          ></b-img>
        <span class="spans">yitipei@163.com</span>
      </div>
      </b-col>
    </b-row> -->
    <b-row class="bak">
      <b-col cols="12" sm="12" md="12" lg="5" xl="5" style="background-color: #90939961;">
        <b-form
          class="form"
          @submit.prevent="onSubmit"
          @reset="onReset"
          novalidate
          inline
          >
          <b-form-group
            id="input-group-5"
            label="姓名"
            label-for="input-5"
            class="input_Body"
          >
          <el-input type="text" class="enemt"  v-model="form.name" @blur="getCode3" placeholder="请输入姓名"></el-input>
            <p class="err" id="err_phonenum" v-show="name">
              <span class="yanzh">{{ name }}</span>
            </p>
          </b-form-group>
          <b-form-group
            id="input-group-6"
            label="手机号"
            label-for="input-5"
            class="input_Body"
          >
          <el-input type="number" class="enemt"  v-model="form.mobile" @blur="getCode4" placeholder="请输入手机号"></el-input>
            <p class="err" id="err_phonenum" v-show="telephone1">
              <span class="yanzh">{{ telephone1 }}</span>
            </p>
          </b-form-group>
          <b-form-group
            id="input-group-8"
            label="公司名称"
            label-for="input-5"
            class="input_Body"
          >
          <el-input type="text" class="enemt"  v-model="form.company_name" @blur="getCode2" placeholder="请输入公司名称"></el-input>
            <p class="err" id="err_phonenum" v-show="compname">
              <span class="yanzh">{{ compname }}</span>
            </p>
          </b-form-group>
          <b-form-group
            id="input-group-9"
            label="公司性质"
            label-for="input-5"
            class="input_Body"
          >
            <el-select
              class="enemt"
              v-model="form.company_type"
              
              clearable
              @change="getCode"
              placeholder="请选择类型"
            >
              <el-option
                v-for="item in foods"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
            <p class="err" id="err_phonenum" v-show="type">
              <span class="yanzh">{{ type }}</span>
            </p>
          </b-form-group>
          <b-button type="submit" class="btn" variant="primary">立即合作</b-button>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import request from"../../../utils/request"
export default {
  name:'contact',
  props:['id'],
  data(){
    return{
      form:{
        name:'',
        company_type:'',
        company_name:'',
        mobile:'',
      },
      foods:[
        '制造',
        '批发',
        '零售'
      ],
      compname:'',
      name:'',
      telephone1:'',
      type:'',
      img1:require('../../../stater/telephone.png'),
      img2:require('../../../stater/phone.png'),
      img3:require('../../../stater/xin.png')
    }
  },
  methods:{
    getCode() {
      //获取手机验证码
      if (!this.form.company_type) {
        this.type = "请选择公司性质";
        return false;
      } else {
        this.type = "";
      }
    },
    getCode2() {
      //获取手机验证码
      if (!this.form.company_name) {
        this.compname = "请输入公司";
        return false;
      } else {
        this.compname = "";
      }
    },
    getCode3() {
      //获取手机验证码
      if (!this.form.name) {
        this.name = "请输入姓名";
        return false;
      } else {
        this.name = "";
      }
    },
    getCode4() {
      //获取手机验证码
      let reg = /^1[3-9][0-9]{9}$/; //以1开头第二位数字为3-9 的11位数字
      if (!reg.test(this.form.mobile)) {
        this.telephone1 = "请输入正确的手机号";
        return false;
      } else {
        this.telephone1 = "";
        return true
      }
    },
    onSubmit(evt) {
      this.getCode()
      this.getCode2()
      this.getCode3()
     let aa= this.getCode4()
      if(!aa){
        return
      }else{
        this.add()
      }
    },
    add(){
      if(this.id){
        this.form.id=this.id
      }
      this.$emit('add',this.form)
    },
    onReset(evt) {

    }
  }
}
</script>
<style>
.el-input--suffix .el-input__inner{
  padding-right: 15px;
}
</style>
<style scoped>
div /deep/.el-input__inner::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #000000c7;
}
.yanzh {
  color: red;
  /* position: absolute; */
  /* margin-left: 35px; */
  padding: 0;
}
.err{
  text-align: left;
  font-size: 12px;
}
.p1{
  text-align: center;
  font-size: 22px;
    font-weight: 500;
    width: 100%;
    /* margin-bottom: 17px; */
    /* background-color: #f6f6f6; */
    line-height: 58px;
    white-space: nowrap;
}
.p2{
  line-height: 14px;
    font-size: 14px;
    color: #414b54;
    text-align: center;
}
.input_Body {
  display: flex;
  margin-bottom: 10px;
  /* margin-left: 93px; */
  height: 54px;
}
div /deep/.d-block{
  width: 77px;
  font-size: 14px;
  color: #fff;
}
.form {
  display: flex;
  flex-direction: column;
    align-items: center;
  /* width: 75.5rem; */
  margin: 2rem auto;
}
.form >>> .form-control {
  box-shadow: none;
  width: 290px;
}
.enemt{
  width: 231px
}
.img{
  width:50px;
  height:50px;
  margin-right: 17px;
}
.spans{
  font-size: 19px;
}
.btn{
  width: 20rem;
  margin: 0 auto;
  background-color: #0d6efd;
}
.fxe{
  display: flex;
    align-items: center;
    justify-content: center;
    margin: 12px 0;
}
.bak{
  background-image: url(../../../stater/6_2.jpg);
  background-repeat: no-repeat;
  background-position: center 0;

  /* background-size: 100% 100%; */
  width:93%;
  height: 23rem;
  margin:0 auto

}
@media screen and (max-width: 650px) {
  .form >>> .form-control {
    width: 83%;
}
.enemt{
  width:83%
}
.btn{
  width: 50%;
}
}
</style>